import * as BreakdownItem from './BreakdownItem';
import { take } from "../util/takePayload";
export const getNew = () => ({});
export const fromGql = (gqlItem) => {
    var _a, _b;
    return (gqlItem && Object.assign(Object.assign({}, take(gqlItem, 'itemsTotal', 'orderTotal')), { itemsBreakdown: ((_a = gqlItem.itemsBreakdown) === null || _a === void 0 ? void 0 : _a.map(BreakdownItem.fromGql)) || [], totalBreakdown: ((_b = gqlItem.totalBreakdown) === null || _b === void 0 ? void 0 : _b.map(BreakdownItem.fromGql)) || [] })) ||
        {};
};
//# sourceMappingURL=PriceBreakdown.js.map